import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectNativeAppMessage, setNativeAppMessage } from '../store/base/commonSlice'
import { stopVideo } from '../store/video/playerSlice'
import { sendNativeAppMessage } from '../utils/nativeAppMessage'

const NativeMessageListener = () => {
  const dispatch = useDispatch()
  const nativeAppMessage = useSelector(selectNativeAppMessage)

  useEffect(() => {
    window.addEventListener('message', messageListener)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    document.addEventListener('message', messageListener)
    return () => {
      window.removeEventListener('message', messageListener)
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      document.removeEventListener('message', messageListener)
    }
  }, [])

  const messageListener = (nativeEvent: MessageEvent) => {
    try {
      if (JSON.parse(nativeEvent.data)?.isNative) {
        sendNativeAppMessage({ message: 'RECEIVED BY WEB APP: ' + JSON.parse(nativeEvent.data)?.message })
        dispatch(setNativeAppMessage(JSON.parse(nativeEvent.data)))
      }
    } catch (e) {
      if (!(e instanceof SyntaxError)) {
        throw e
      }
    }
  }

  useEffect(() => {
    if (
      nativeAppMessage?.message === 'androidHardwareBackPress' ||
      nativeAppMessage?.message === 'exitFullscreenVideo'
    ) {
      dispatch(stopVideo())
    }
  }, [nativeAppMessage])

  return null
}

export default NativeMessageListener
